<div>
  <br>
<form [formGroup]="form" class="formHeight">
  <div class="row" >
    <div class="col-sm-8" >
      <div style="left: 4%; position: relative;">

<!--        <hr>-->
        <div >
          <alert type="info">
            <div style="padding-bottom: 6px;">
              <span><strong><i class="fas fa-info-square"></i> How-to:</strong></span>
              <span><i  [class]="isCollapsed ? 'fal fa-chevron-up':'fal fa-chevron-down'"  (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" style=" display: flex;justify-content: flex-end; margin-left: auto;
                         margin-right: 0; margin-top: -23px;"></i>
              </span>
              <span *ngIf="!isCollapsed"><br/></span>
              <span id="collapseBasic" [collapse]="isCollapsed">
                <span>The first column contains the form to update the invoice line translations.</span><br/>
                <span>The second column shows the result that will be displayed on your invoices.</span><br/>
                <span>The service, start and end dates in the second column are examples; the actual dates will appear on your invoices.</span><br/>
                <span>Please ensure to correctly follow the  &#123;xxx&#125;.</span><br/>
              </span>

            </div>
          </alert>
        </div>

      </div>
    </div>
    <div class="col-sm-2" >
    </div>
    <div class="col-sm-2" >
      <div class="row">
        <span class="col-sm-6"> <label style=" margin-top: 6px;">Select language:</label>  </span>
            <span class="col-sm-6"> <select
                    class="form-control"
                    (change)="onChange($event)">
              <option value="1"  [selected]="companyLanguageId ===1">English</option>
              <option value="19"  [selected]="companyLanguageId ===19">Dutch</option>
              <option value="26"  [selected]="companyLanguageId ===26">French</option>
              <option value="30"  [selected]="companyLanguageId ===30">German</option>
              <option value="71"  [selected]="companyLanguageId ===71">Spanish</option>
            </select>
            </span>
      </div>
    </div>
  </div>
    <div class="row" >
    <div class="col-sm-6" >
      <ul class="">
        <div class="">
          <storever-element-group
            [icon]="'fal fa-info-square'"
            [title]="'Variables'"
            [config]="formReplacementConfig.config"
            [form]="form.get(['replacement'])"
            [isAdd]="isAdd"
            [isEdit]="isEdit"
            [status]="'0'"
            [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'Variables'}"
            (save)="replacementSave()"
            (undo)="replacementUndo()"
            [stylingClass]="'dynamic-form'">
          </storever-element-group>
        </div>
      </ul>
      </div>
      </div>
  <div class="row" >
    <div class="col-sm-6" >
      <ul class="">
        <div class="">
          <storever-element-group
            [icon]="'far fa-exclamation'"
            [title]="'Global'"
            [config]="formGlobalConfig.config"
            [form]="form.get(['globalForm'])"
            [isAdd]="isAdd"
            [isEdit]="isEdit"
            [status]="'0'"
            [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'global'}"
            (save)="saveGlobal()"
            (undo)="undoGlobal()"
            [stylingClass]="'dynamic-form'">
          </storever-element-group>
        </div>
      </ul>
    </div>
    <div class="col-sm-6" >
          <div style="line-height: 2.3;">
            <div style=" position: relative; margin-top: 4.5%;">
              <div>{{transformFormInLabel(form.get(['globalForm' ,'loc']))}}</div>
              <div>{{transformFormInLabel(form.get(['globalForm' ,'locDay']))}}</div>
              <div>{{transformFormInLabel(form.get(['globalForm' ,'locDayMon']))}}</div>
            </div>
          </div>
    </div>
  </div>
  <div class="row" >
    <div class="col-sm-6" >
      <ul class="">
        <div class="">
          <storever-element-group
            [icon]="'far fa-money-check-alt'"
            [title]="'CONTRACT_FORM_RULES_FEES'"
            [config]="formFeeConfig.config"
            [form]="form.get(['feesForm'])"
            [isAdd]="isAdd"
            [isEdit]="isEdit"
            [status]="'0'"
            [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'order', case: 'fee'}"
            (save)="saveFee()"
            (undo)="undoFee()"
            [stylingClass]="'dynamic-form'">
          </storever-element-group>
        </div>
      </ul>
      </div>
    <div class="col-sm-6" style="line-height: 2.3;">
        <div style=" position: relative; margin-top: 4.5%;">
          <div  *ngFor="let item of formFeeConfig.config; let i = index">
            {{transformFormInLabel(form.get(['feesForm' , item.controlName[0]]))}}
          </div>
        </div>
    </div>
    </div>
  </form>
</div>
<div *ngIf="false" style="display:flex;">
  <pre style="flex:1;word-break:break-word;line-height:2;">{{form.get(['feesForm']).value  |json}}</pre>
</div>
